import Icon from 'veui/components/Icon'
import { IconPvShield } from 'dls-icons-vue'

Icon.register('pv-shield', IconPvShield)
